// usePermissions - the one place that answers "does the signed-in user
// hold permission X" in the SPA.
//
//   const { has, isAdmin, perms } = usePermissions();
//   if (has(ALL_PERMISSIONS.ISSUE_CREATE)) ...
//
// Same rule the 40+ inline copies use: effective permissions are the
// intersection of the company set, the user's set and the platform's
// full list; platform admins and company admins pass every key.
// (Owner-vs-partner questions on ONE project are answered by
// useProjectAccess, not here.)
import { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";

export default function usePermissions() {
  const userInfo = useSelector((s) => s.user?.userInfo);
  const userPerms = useSelector((s) => s.user?.userPermission);
  const companyPerms = useSelector((s) => s.user?.companyPermission);
  const allPerms = useSelector((s) => s.user?.allPermission);

  const perms = useMemo(() => {
    if (!Array.isArray(allPerms)) return [];
    return allPerms
      .filter((p) => companyPerms?.includes(p))
      .filter((p) => userPerms?.includes(p));
  }, [allPerms, companyPerms, userPerms]);

  const isAdmin = !!(userInfo?.admin || userInfo?.companyAdmin);
  const has = useCallback(
    (key) => isAdmin || perms.includes(key),
    [isAdmin, perms]
  );
  const hasAny = useCallback(
    (...keys) => isAdmin || keys.some((k) => perms.includes(k)),
    [isAdmin, perms]
  );

  return { has, hasAny, isAdmin, perms, userInfo };
}
